import { render, staticRenderFns } from "./OffsetDetail.vue?vue&type=template&id=32979be4&scoped=true&"
import script from "./OffsetDetail.vue?vue&type=script&lang=js&"
export * from "./OffsetDetail.vue?vue&type=script&lang=js&"
import style0 from "./OffsetDetail.vue?vue&type=style&index=0&id=32979be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32979be4",
  null
  
)

export default component.exports